export default __webpack_public_path__ + "static/media/a_r.d595727c.wav";